import React, { useEffect, useRef, useState } from 'react';
import { Paper, Popper, TextField } from "@mui/material";
import CountryFlag from 'react-country-flag';
import Autocomplete from '@mui/material/Autocomplete';
import { listaCodigoInternacionalTelefone } from 'app/utils/ListaCodigoInternacionalTelefone';
const estilosSelecionarCodigoTelefoneInternacional = require('./selecionar-codigo-telefone-internacional.module.scss').default


export type CountryCode = {
  code: string;
  country: string;
  dialCode: string;
}

export type SelecionarCodigoTelefoneInternacionalProps = {
  value: CountryCode;
  disabled?: boolean;
  style?: React.CSSProperties;
  onLimpar: () => void;
  onChange: (value: CountryCode) => void;
}



const SelecionarCodigoTelefoneInternacional = (props: SelecionarCodigoTelefoneInternacionalProps) => {
  const [ mostrarPesquisa, setMostrarPesquisa ] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  
    useEffect(() => { 
      if (open) {
        inputRef.current?.focus();
      }
    
    }, [open]);
    useEffect(() => { 
      if (open) {
        inputRef.current?.focus();
      }
    }, [props.value]);

  return (

    <div 
      onClick={() =>{
        if (props.value == null)
          setOpen(!open);
        }
      }
    >
    <Autocomplete
      className={open ? estilosSelecionarCodigoTelefoneInternacional.form_selecionado :  estilosSelecionarCodigoTelefoneInternacional.form_nao_selecionado}
      classes={{
        clearIndicator: 'no-global-button',
        popupIndicator: 'no-global-button',
      }}
      clearText="Limpar"
      openText="Listar"
      style={{
        ...(props.style != null ? props.style : {}),
      }}
      value={props.value}
      disabled={props.disabled ?? false}
      autoHighlight
      autoSelect={false}
      onChange={(event, newValue) => {
       // setValue(newValue as CountryCode);
        props.onChange(newValue as CountryCode); 
      }}
      onOpen={(event) => {
        event.stopPropagation();
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onInputChange={(event, newValue, reason) => {
        if (reason === 'clear') {
          props.onLimpar();
        }
      }}
      onBlur={(event) => { setOpen(false);}}
      options={listaCodigoInternacionalTelefone}
      getOptionLabel={(option) => `${option.country} (${option.dialCode})`}
      filterOptions={(options, state) => {
        return options.filter((option) =>
          option.code.toLowerCase().includes(state.inputValue.toLowerCase()) ||
          option.country.toLowerCase().includes(state.inputValue.toLowerCase()) ||
          option.dialCode.includes(state.inputValue)
        );
      }}
      // Migração MUI v4 -> v9: a assinatura de renderOption virou (props, option, state) — o
      // `props` do <li> passou a ser o PRIMEIRO parâmetro. No v4 este código fazia
      // `<li {...state}>`, espalhando { inputValue, selected } como atributos de DOM; agora
      // espalha os props corretos que o Autocomplete fornece. O `key` sai do spread porque o
      // React exige que ele seja passado explicitamente.
      renderOption={(optionProps, option: CountryCode) => {
        const { key, ...restoProps } = optionProps as React.HTMLAttributes<HTMLLIElement> & { key?: React.Key }
        return (
          <li key={key} {...restoProps}>
            <CountryFlag countryCode={option.code} svg style={{ marginRight: 8 }} />
            {option.country} ({option.dialCode})
          </li>
        )
      }}
      // Migração MUI v4 -> v9: `PopperComponent`/`PaperComponent` foram substituídos pelo `slots`.
      slots={{
        popper: ({ children, ...popperProps }: any) => (
          <Popper {...popperProps} style={{ width: '18rem'}}>
            {children}
          </Popper>
        ),
        paper: ({ children }: any) => (
          <Paper style={{ width: '18rem' }} elevation={1}>
            {children}
          </Paper>
        ),
      }}
      renderInput={(params) => ( 
        <TextField
          {...params}
          inputRef={inputRef}
          label="País"
          variant="outlined"
          fullWidth
          name='pesquisaCodigoTelefoneInternacional'
          // Migração MUI v4 -> v9: `InputProps` (do TextField) e `params.InputProps` (do
          // Autocomplete) foram substituídos por `slotProps.input`. Como `{...params}` acima já
          // espalha o `slotProps` do Autocomplete, é preciso reespalhá-lo aqui antes de
          // sobrescrever só o slot `input` — senão o resto (inputLabel, htmlInput) se perde.
          slotProps={{
            ...params.slotProps,
            input: {
              ...(params.slotProps?.input as any),
              style: { backgroundColor: 'white',
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 0,
              },
              startAdornment: props.value ? (
                <>
                  <CountryFlag countryCode={props.value?.code} svg style={{ marginRight: 8 }} />
                  {  !open && props.value?.dialCode}
                </>
              ) : null,
            },
          }}
         
        />
      )}
    />
    </div>
  );
};

export default SelecionarCodigoTelefoneInternacional;
